import { render, staticRenderFns } from "./SchmuckstueckePage.vue?vue&type=template&id=2bd3f932&scoped=true&"
import script from "./SchmuckstueckePage.vue?vue&type=script&lang=js&"
export * from "./SchmuckstueckePage.vue?vue&type=script&lang=js&"
import style0 from "./SchmuckstueckePage.vue?vue&type=style&index=0&id=2bd3f932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3f932",
  null
  
)

export default component.exports